import {
  CloudflareSyncState,
  CloudflareZonesResponse,
  CtiLookup,
  IntegrationsView,
  type CaptchaInput,
  type CloudflareInput,
  type CtiInput,
  type IntegrationName,
} from '@bartizo/shared';
import { apiRequest } from './client.js';

/** The integrations (P11.9.3, P11.9.5, P11.9.6). Secrets go in and never come back. */

export const getIntegrations = (): Promise<IntegrationsView> =>
  apiRequest('/integrations', { schema: IntegrationsView });

const put = (name: IntegrationName, body: unknown): Promise<IntegrationsView> =>
  apiRequest(`/integrations/${name}`, { method: 'PUT', body, schema: IntegrationsView });

export const saveCaptcha = (input: CaptchaInput): Promise<IntegrationsView> =>
  put('captcha', input);
export const saveCloudflare = (input: CloudflareInput): Promise<IntegrationsView> =>
  put('cloudflare', input);
export const saveCti = (input: CtiInput): Promise<IntegrationsView> => put('crowdsec_cti', input);

export const removeIntegration = (name: IntegrationName): Promise<IntegrationsView> =>
  apiRequest(`/integrations/${name}`, { method: 'DELETE', schema: IntegrationsView });

export const cloudflareZones = (
  accountId: string,
  token?: string,
): Promise<CloudflareZonesResponse> =>
  apiRequest('/integrations/cloudflare/zones', {
    method: 'POST',
    body: { accountId, ...(token === undefined || token === '' ? {} : { token }) },
    schema: CloudflareZonesResponse,
  });

export const syncCloudflareNow = (): Promise<CloudflareSyncState> =>
  apiRequest('/integrations/cloudflare/sync', { method: 'POST', schema: CloudflareSyncState });

export const getReputation = (ip: string): Promise<CtiLookup> =>
  apiRequest(`/addresses/${encodeURIComponent(ip)}/reputation`, { schema: CtiLookup });
